/**
 * Wire shape of `NumberBlockMandantData` from phoneservice-api.
 * `(vorwahl, prefix)` is the unique key — there is no numeric id.
 */
export interface NumberBlockDto {
  vorwahl: string;
  prefix: string;
  carrier: string;
  staOrt: string;
  staLand: string;
}

/**
 * Client-side shape. `key` is a composite of `vorwahl` + `prefix` used for
 * trackBy, selection Sets and row identity in AG-Grid.
 */
export interface NumberBlock extends NumberBlockDto {
  key: string;
}

export function toNumberBlock(dto: NumberBlockDto): NumberBlock {
  return { ...dto, key: `${dto.vorwahl}|${dto.prefix}` };
}
